<template>
	<div id="CharingOrderList" class="border-container" v-if="$auth('order.list')">
		<a-spin :spinning="loading" v-if="loading" class="loading-incontent"></a-spin>
		<div class="title-container">
			<div class="title-area"><span>{{type !== CHARGING_TYPE.POSTPAY_FAIL ? '充电订单列表' : '欠款订单列表'}}</span></div>
			<div class="btn-area" >
				<template v-if="(type === CHARGING_TYPE.PRECONTRACT || type === CHARGING_TYPE.REFUND) && !history">
					<a-button type="primary" :disabled="orderExport.disabled" @click="handleExportConfirm(true)" ghost v-if="$auth('ADMIN')">VIP导出</a-button>
					<a-button type="primary" :disabled="orderExport.disabled" @click="handleExportConfirm(false)">导出</a-button>
				</template>
				<template v-if="type === CHARGING_TYPE.ALL && !history">
					<div class="tip">数据采集截止时间：{{ tipEndTime | timeFilter }}</div>
				</template>
			</div>
		</div>
		<div class="list-container visible">
			<div class="operate-container">
				<div class="search-area" :class="[showDown ? 'multi-line' : 'one-line', $auth('ADMIN') ? 'admin' : 'sp', type === CHARGING_TYPE.TODAY ? 'today' : '', history ? 'history' : '', precontract ? 'precontract' : '', type === CHARGING_TYPE.REFUND ? 'refund': '', type === CHARGING_TYPE.POSTPAY_FAIL ? 'postpay-fail': '']">
					<!-- 今日订单 -->
                    <template v-if="type !== CHARGING_TYPE.POSTPAY_FAIL">
                        <a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item time-select" v-if="type == 1">
                            <div class="key"><span>创建时间:</span></div>
                            <div class="value">
                                <a-time-picker :allow-clear="false" @change="handleBeginTimeChange" :value="defaultBegin" valueFormat="X">
                                    <span slot="suffixIcon"></span>
                                </a-time-picker>
                                <span class="range">~</span>
                                <a-time-picker :allow-clear="false" @change="handleEndTimeChange" :value="defaultEnd" valueFormat="X">
                                    <span slot="suffixIcon"></span>
                                </a-time-picker>
                            </div>
                        </a-col>
                        <a-col :xxl="12" :xl="16" :md="24" class="search-item time-range-select" v-else>
                            <div class="key"><span>创建时间:</span></div>
                            <div class="value">
                                <SelectTime v-model="searchForm.createTime" @change="handleTimeChange('createTime')" :disabledDate="disabledDate"/>
                            </div>
                        </a-col>
                    </template>

					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item">
						<div class="key"><span>订单号:</span></div>
						<div class="value">
							<a-input placeholder="请输入" v-model="searchForm.orderSn" @keydown.native.enter="handleSearch" />
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item value-select" v-if="type !== CHARGING_TYPE.POSTPAY_FAIL">
						<div class="key"><span>结束原因:</span></div>
						<div class="value">
							<a-tree-select
								v-model="searchForm.finish_code"
								size="small" allow-clear show-search
								placeholder="请选择"
								searchPlaceholder="请输入"
								:tree-data="finishCodeNewList"
								:dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
								dropdownClassName="resource-tree-select"
								treeNodeFilterProp="label"
								:replaceFields="{children:'children', key:'value', value:'value' }"
							>
								<template slot="tooltip" slot-scope="item" >
									<a-tooltip placement="left" destroy-tooltip-on-hide overlayClassName="select-tip" :title="$Filter.orderFinishCodeFilter(item.value, 'CHARGING', 'tip')">
										{{ $Filter.orderFinishCodeFilter(item.value) }}
									</a-tooltip>
								</template>
							</a-tree-select>
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item" v-if="!history">
						<div class="key"><span>用户手机:</span></div>
						<div class="value">
							<a-input placeholder="请输入" v-model="searchForm.phone" @keydown.native.enter="handleSearch" />
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item value-select" v-if="$auth('ADMIN')">
						<div class="key"><span>运营商:</span></div>
						<div class="value">
							<SelectOperator placeholder="请选择所属运营商" v-model="searchForm.operator_id" @changed="handleSearch" />
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item value-select">
						<div class="key"><span>片区:</span></div>
						<div class="value">
							<a-select v-model="searchForm.org_id" show-search option-filter-prop="children" allow-clear @changed="handleSearch" :disabled="!searchForm.operator_id" :placeholder="searchForm.operator_id ? '请选择' : '请先选择运营商'">
								<a-select-option v-for="item of orgList" :key="item.id" :value="item.id" :label="item.name">{{ item.name }}</a-select-option>
							</a-select>
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item value-select">
						<div class="key"><span>充电站:</span></div>
						<div class="value">
							<a-select v-model="searchForm.station_id" @changed="handleSearch" show-search option-filter-prop="children" allow-clear :disabled="!searchForm.operator_id" :placeholder="searchForm.operator_id ? '请选择' : '请先选择运营商'">
								<a-select-option v-for="item of stationList" :key="item.id" :value="item.id" :label="item.name">{{ item.name }}</a-select-option>
							</a-select>
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item value-select" v-if="!precontract">
						<div class="key"><span>设备类型:</span></div>
						<div class="value">
							<a-select placeholder="请选择" v-model="searchForm.device_type" @changed="handleSearch" show-search option-filter-prop="children" allow-clear>
								<a-select-option v-for="item of deviceTypeList" :key="item.value" :value="item.value" :label="item.intact_text">{{ item.intact_text }}</a-select-option>
							</a-select>
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item value-select" v-if="!(precontract || history) && type !== CHARGING_TYPE.POSTPAY_FAIL">
						<div class="key"><span>充电类型:</span></div>
						<div class="value">
							<a-select placeholder="请选择" v-model="searchForm.power_mode" @changed="handleSearch" show-search option-filter-prop="children" allow-clear>
								<a-select-option v-for="item of powerModeList" :key="item.value" :value="item.value" :label="item.text">{{ item.text }}</a-select-option>
							</a-select>
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item">
						<div class="key"><span>厂商UID:</span></div>
						<div class="value">
							<a-input placeholder="请输入" v-model="searchForm.socketUid" @keydown.native.enter="handleSearch" />
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item">
						<div class="key"><span>网关UID:</span></div>
						<div class="value">
							<a-input placeholder="请输入" v-model="searchForm.gatewayUid" @keydown.native.enter="handleSearch" />
						</div>
					</a-col>
					<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item" v-if="!history">
						<div class="key"><span>商户单号:</span></div>
						<div class="value">
							<a-input placeholder="请输入" v-model="searchForm.outerSn" @keydown.native.enter="handleSearch" />
						</div>
					</a-col>
					<!-- <a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item value-select" v-if="!precontract">
						<div class="key"><span>预约订单:</span></div>
						<div class="value">
							<a-select placeholder="请选择" v-model="searchForm.flag_booking" @changed="handleSearch" show-search option-filter-prop="children" allow-clear>
								<a-select-option v-for="item of flagBookingList" :key="item.value" :value="item.value" :label="item.text">{{ item.text }}</a-select-option>
							</a-select>
						</div>
					</a-col> -->
					<template v-if="type !== CHARGING_TYPE.POSTPAY_FAIL">
						<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item" v-if="!history && type === CHARGING_TYPE.ALL">
							<div class="key"><span>车牌号:</span></div>
							<div class="value">
								<a-input placeholder="请输入完整车牌号" v-model="searchForm.license_plate_number" @keydown.native.enter="handleSearch" />
							</div>
						</a-col>
						<a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item" v-if="!(precontract || history)">
							<div class="key"><span>VIN码:</span></div>
							<div class="value">
								<a-input placeholder="请输入" v-model="searchForm.vin" @keydown.native.enter="handleSearch" />
							</div>
						</a-col>
                        <!-- TODO 搜索栏高度 -->
                        <a-col :xxl="6" :xl="8" :lg="12" :md="24" class="search-item value-select" v-if="$auth('ADMIN')">
                            <div class="key"><span>刷蓝模式:</span></div>
                            <div class="value">
                                <a-select placeholder="请选择刷蓝模式" v-model="searchForm.alipay_shualan_type" @changed="handleSearch" allow-clear>
                                    <a-select-option v-for="item of alipayShualanTypeList" :key="item.value">{{ item.text }}</a-select-option>
                                </a-select>
                            </div>
                        </a-col>
					</template>
					<template v-if="type !== CHARGING_TYPE.TODAY">
						<a-col :xxl="12" :xl="16" :md="24" class="search-item time-range-select">
							<div class="key"><span>结束时间:</span></div>
							<div class="value">
								<SelectTime v-model="searchForm.finishTime" @change="handleTimeChange('finishTime')" :disabledDate="disabledDate"/>
							</div>
						</a-col>
						<a-col :xxl="12" :xl="16" :md="24" class="search-item time-range-select" v-if="type !== CHARGING_TYPE.POSTPAY_FAIL">
							<div class="key"><span>结算时间:</span></div>
							<div class="value">
								<SelectTime v-model="searchForm.remitTime" @change="handleTimeChange('remitTime')" :disabledDate="disabledDate"/>
							</div>
						</a-col>
					</template>
					<template v-if="type === CHARGING_TYPE.REFUND">
						<a-col :xxl="12" :xl="16" :md="24" class="search-item time-range-select">
							<div class="key"><span>退款时间:</span></div>
							<div class="value">
								<SelectTime v-model="searchForm.refundTime" @change="handleTimeChange('refundTime')" />
							</div>
						</a-col>
					</template>
				</div>
				<div class="btn-area">
					<a-button type="link" @click="showDown = !showDown">
						<span>
							{{ showDown ? '收起' : '展开' }}
							<a-icon type="down" class="operate-icon" :class="{ up: showDown }" />
						</span>
					</a-button>
					<a-button type="primary" @click="handleSearch">查询</a-button>
					<a-button @click="handleSearchReset">重置</a-button>
				</div>
			</div>
			<div class="table-container">
				<ListLoadingMask v-if="init"/>
				<div class="field-select" @click="handleFieldSelectShow">
					<a-tooltip title="选择要显示的字段"><i class="icon i-eyes" /></a-tooltip>
				</div>
				<a-table :class="{'opacity': init}" :columns="tableColumns | tableFieldsFilter(userType)" :data-source="tableData" :row-key="(record) => record.id" :pagination="false" :scroll="{ x: true }"
					:row-selection="type === CHARGING_TYPE.POSTPAY_FAIL ? rowSelection : null">
					<template>
						<!-- 过滤ICON -->
						<div slot="filter_icon" class="filter_icon">
							<i class="icon i-dropdown" />
						</div>
					</template>
					<template>
						<!-- 过滤下拉框 -->
						<div slot="order_status_filter" class="filter_dropdown" v-if="![CHARGING_TYPE.UNPAY, CHARGING_TYPE.POSTPAY_FAIL].includes(type)">
							<div v-for="(item, index) of statusList" :key="index" @click="handleFilterChange('order_status', item.value)" class="filter_dropdown_item" :class="{ active: searchForm.order_status == item.value }">
								{{ item.text }}
							</div>
						</div>
                        <template v-if="type !== CHARGING_TYPE.POSTPAY_FAIL">
                            <div slot="pay_method_filter" class="filter_dropdown">
                                <div v-for="(item, index) of payMethodList" :key="index" @click="handleFilterChange('pay_method', item.value)" class="filter_dropdown_item" :class="{ active: searchForm.pay_method == item.value }">
                                    {{ item.text }}
                                </div>
                            </div>
                            <div slot="settle_status_filter" class="filter_dropdown">
                                <div v-for="(item, index) of clearingStatusList" :key="index" @click="handleFilterChange('settle_status', item.value)" class="filter_dropdown_item" :class="{ active: searchForm.settle_status == item.value }">
                                    <a-tooltip :title="$Filter.clearingStatusTipFilter(item.value, 'tip')" placement="left" destroy-tooltip-on-hide>
                                        {{ item.text }}
                                    </a-tooltip>
                                </div>
                            </div>
                        </template>
						<div slot="refund_status_filter" class="filter_dropdown">
							<div v-for="(item, index) of refundStatusList" :key="index" @click="handleFilterChange('refund_status', item.value)" class="filter_dropdown_item" :class="{ active: searchForm.refund_status == item.value }">
								{{ item.list_text }}
							</div>
						</div>
                        <div slot="pursue_order_status_filter" class="filter_dropdown" v-if="type === CHARGING_TYPE.POSTPAY_FAIL">
							<div v-for="(item, index) of pursueStatusList" :key="index" @click="handleFilterChange('pursue_order_status', item.value)" class="filter_dropdown_item" :class="{ active: searchForm.pursue_order_status == item.value }">
								{{ item.text }}
							</div>
						</div>
					</template>

					<template slot="sn" slot-scope="text, record">
						<a-tooltip :title="text" destroy-tooltip-on-hide>
							<a-button type="link" @click="routerChange(1, record)" v-if="$auth('order.detail')">{{ text }} </a-button>
							<span v-else>{{ text }}</span>
						</a-tooltip>
					</template>
					<template slot="name" slot-scope="text">
						<a-tooltip :title="text" destroy-tooltip-on-hide>
							<span class="text-ellipsis" style="maxwidth: 150px">{{ text }}</span>
						</a-tooltip>
					</template>
					<template slot="license_plate_number" slot-scope="text">
						<a-tooltip :title="text" destroy-tooltip-on-hide v-if="text">
							<span class="text-ellipsis" style="maxwidth: 150px">{{ text }}</span>
						</a-tooltip>
						<span v-else>{{ text || '-' }}</span>
					</template>
					<template slot="device_info" slot-scope="text, record">
						<div>{{ record.socket_uid + '-' + record.node_index + '-' + $Util.getOrderPortName(record) }}</div>
					</template>
					<template slot="order_status" slot-scope="text">
						<!-- 订单状态 -->
						<span class="item-status" :class="text | orderStatusFilter('color')">
							<i class="icon i-point"></i>
							{{ text | orderStatusFilter }}
						</span>
					</template>
					<template slot="pursue_order_status" slot-scope="text">
						<!-- 欠款状态 -->
						<span class="item-status" :class="$Filter.valueFilter(text, 'CHARGING.PURSUE_ORDER_STATUS_MAP', 'color')">
							<i class="icon i-point"></i>
							{{ $Filter.valueFilter(text, 'CHARGING.PURSUE_ORDER_STATUS_MAP') }}
						</span>
					</template>
					<template slot="price" slot-scope="text, record">
						<span class="bold">{{ record | isChargeFullFilter }}</span>
					</template>

					<template slot="money_consumed" slot-scope="text, record">
						<span class="bold" v-if="$Filter.isFinishOrder(record.status)">
							<template v-if="$auth('ADMIN') || PAY_METHOD_M.TIME_CARD.includes(record.pay_method)">￥{{ text | moneyFilter }}</template>
							<!-- <template v-else>￥{{((record.price >= text) ? text : record.price ) | moneyConsumedFilter}}</template> -->
							<template v-else>￥{{ record | moneyConsumedFilter }}</template>
						</span>
						<template v-else>-</template>
					</template>

					<template slot="charge" slot-scope="text, record">
						<span class="bold" v-if="$Filter.isFinishOrder(record.status)">￥{{ $Filter.moneyFilter(text) }}</span>
						<template v-else>-</template>
					</template>

					<template slot="money" slot-scope="text, record">
						<span class="bold">{{ $Filter.moneyFilter(text, 2) }}</span>
					</template>
					<template slot="settle_energy_charge" slot-scope="text">
						<span class="bold">{{ text | moneyFilter(2) }}</span>
					</template>

					<template slot="pay_method" slot-scope="text">
						<!-- 付款方式 -->
						<i class="icon" :class="text | orderPayMethodFormat('icon')"></i>
                        {{ $auth('ADMIN') ? $Filter.orderPayMethodFormat(text, 'admin_text') : $Filter.orderPayMethodFormat(text) }}
					</template>
					<template slot="settle_status" slot-scope="text, record">
						<!-- 结算状态 -->
						<span :style="text | clearingStatusFilter('color')" v-if="$Filter.isPayByCash(record.pay_method)">
							<a-tooltip :title="$Filter.clearingStatusTipFilter(text, 'tip')" placement="top" destroy-tooltip-on-hide>
								{{ text | clearingStatusFilter }}
							</a-tooltip>
						</span>
						<template v-else>-</template>
					</template>
					<template slot="finish_code" slot-scope="text, record">
						<!-- 结束原因 -->
						<a-tooltip v-if="text" :title="$Filter.orderFinishCodeFilter(text, 'CHARGING', 'tip')">
							{{ $Filter.orderFinishCodeFilter(text) }}
						</a-tooltip>
						<template v-else>-</template>
						<!-- <a-tooltip v-if="$Filter.isFinishOrder(record.status)" :title="$Filter.orderFinishCodeFilter(text, 'CHARGING', 'tip')">
							{{ $Filter.orderFinishCodeFilter(text) }}
						</a-tooltip>
						<template v-else-if="text && record.status === CHARGING_STATUS.INIT">{{ $Filter.orderFinishCodeFilter(text) }}</template>
						<template v-else>-</template> -->
					</template>
					<template slot="time" slot-scope="text">
						{{ text | timeFilter }}
					</template>
					<template slot="flag_booking" slot-scope="text, record">
						<span class="bold">{{ text | flagBookingFilter }}</span>
					</template>
					<template slot="refund_status" slot-scope="text">
						{{ text ? $Filter.orderRefundStatusFilter(text, 'list_text') : '-' }}
					</template>

					<template slot="operation" slot-scope="text, record">
						<a-button type="link" @click='handleCancelPrecontract(record)' v-if="($auth('pre.config.update') || $auth('ADMIN')) && precontract && record.status === CHARGING_STATUS.PRE_SUCCESS" class="danger">取消预约</a-button>
						<!-- <i class="icon i-delete"/> -->
					</template>
				</a-table>
			</div>
			<div class="paging-container" :class="type === CHARGING_TYPE.POSTPAY_FAIL ? 'with-operate' : ''">
				<div class="operate-area" v-if="type === CHARGING_TYPE.POSTPAY_FAIL">
					<a-button type="danger" ghost @click="handleBatchClearingOrder" :disabled="!selectedRowKeys.length">
						<i class="icon i-delete" />批量结算
					</a-button>
					<div class="select-length-tip">已选中 {{selectedRowKeys.length}} 条数据</div>
				</div>
				<a-pagination show-quick-jumper show-less-items :show-total="(total) => `共 ${total} 条记录`" :hide-on-single-page="false" :total="total" :current="currPage" :default-page-size="20" @change="pageChange" />
			</div>
		</div>
		<template class="modal-container">
			<a-modal v-model="fieldVisible" title="字段选择" class="field-select-modal" :width="630" :after-close="handleFieldSelectClose">
				<div class="modal-content">
					<p>请选择要显示的字段</p>
					<a-checkbox-group v-model="fieldKeys" :options="fieldList | tableFieldsFilter(userType)" />
				</div>
				<template slot="footer">
					<a-button type="primary" @click="handleFieldSelectConfirm">确定</a-button>
					<a-button @click="fieldVisible = false">取消</a-button>
				</template>
			</a-modal>
		</template>
	</div>
</template>

<script>
import Core from '../../core';
import moment from 'moment';
import axios from 'axios';

import { TreeSelect } from 'ant-design-vue';
const SHOW_PARENT = TreeSelect.SHOW_PARENT;

const LOGIN_TYPE = Core.Const.LOGIN_TYPE;
const PAY_METHOD = Core.Const.PAY.METHOD;
const CHARGING_TYPE = Core.Const.CHARGING.TYPE;
const FLAG_BOOKING = Core.Const.ORDER.FLAG_BOOKING;
const CHARGING_STATUS = Core.Const.CHARGING.STATUS;
const PURSUE_ORDER_STATUS = Core.Const.CHARGING.PURSUE_ORDER_STATUS;
const PAY_METHOD_M = Core.Const.PAY.METHOD_MARK;

const _tableColumns = [
	{
		title: '订单号',
		dataIndex: 'sn',
		scopedSlots: { customRender: 'sn' },
		display: true,
	},
	{
		title: '创建时间',
		dataIndex: 'create_time',
		scopedSlots: { customRender: 'time' },
		width: '190px',
		display: true,
	},
	// {
	// 	title: '充电方式',
	// 	dataIndex: 'detail.flag_booking',
	// 	scopedSlots: { customRender: 'flag_booking' },
	// 	display: true,
	// },
	{
		title: '订单状态',
		dataIndex: 'status',
		key: 'order_status',
		slots: { filterIcon: 'filter_icon' },
		scopedSlots: { customRender: 'order_status', filterDropdown: 'order_status_filter' },
		display: true,
	},
    {
		title: '欠款状态',
		dataIndex: 'pursue_order_status',
		slots: { filterIcon: 'filter_icon' },
		scopedSlots: { customRender: 'pursue_order_status', filterDropdown: 'pursue_order_status_filter' },
		display: true,
	},
	{
		title: '结束原因',
		dataIndex: 'finish_code',
		scopedSlots: { customRender: 'finish_code' },
		display: true,
	},
	{
		title: '支付金额',
		dataIndex: 'price',
		scopedSlots: { customRender: 'price' },
		width: '100px',
		display: true,
	},
	{
		title: '付款方式',
		dataIndex: 'pay_method',
		slots: { filterIcon: 'filter_icon' },
		scopedSlots: { customRender: 'pay_method', filterDropdown: 'pay_method_filter' },
		display: true,
	},
	{
		title: '结算状态',
		key: 'settle_status',
		dataIndex: 'clearing_status',
		slots: { filterIcon: 'filter_icon' },
		scopedSlots: { customRender: 'settle_status', filterDropdown: 'settle_status_filter' },
		display: true,
	},
	{
		title: '车牌号',
		dataIndex: 'detail.license_plate_number',
		scopedSlots: { customRender: 'license_plate_number' },
		display: true,
		width: '100px',
	},
	{
		title: 'VIN码',
		dataIndex: 'detail.vin',
		scopedSlots: { customRender: 'name' },
		display: true,
		width: '100px',
	},
	{
		title: '用户昵称',
		dataIndex: 'user_name',
		scopedSlots: { customRender: 'name' },
		display: true,
	},
	{
		title: '运营商',
		dataIndex: 'operator_name',
		scopedSlots: { customRender: 'name' },
		role: [LOGIN_TYPE.ADMIN],
		display: true,
	},
	{
		title: '片区名称',
		dataIndex: 'org_name',
		scopedSlots: { customRender: 'name' },
		display: true,
	},
	{
		title: '充电站名称',
		dataIndex: 'station_name',
		scopedSlots: { customRender: 'name' },
		display: true,
	},
	{
		title: '厂商UID/设备号/插口号',
		dataIndex: 'device_info',
		scopedSlots: { customRender: 'device_info' },
		display: true,
	},
	{
		// title: '实际花费',
		title: '充电实际花费',
		dataIndex: 'money_consumed',
		scopedSlots: { customRender: 'money_consumed' },
		width: '100px',
		display: true,
	},
	{
		title: '实际收费',
		// dataIndex: 'charge',
		dataIndex: 'sum_price_info.charge',
		scopedSlots: { customRender: 'charge' },
		width: '100px',
		display: true,
	},
	{
		title: '打款金额',
		dataIndex: 'clearing_money',
		scopedSlots: { customRender: 'money' },
		width: '100px',
		display: true,
	},
	{
		title: '结算后退款金额',
		dataIndex: 'refund_money',
		scopedSlots: { customRender: 'money' },
		width: '100px',
		display: true,
	},
	{
		title: '结算后退款状态',
		dataIndex: 'refund_status',
		slots: { filterIcon: 'filter_icon' },
		scopedSlots: { customRender: 'refund_status', filterDropdown: 'refund_status_filter' },
		width: '100px',
		display: true,
	},
	{
		title: '结算电费',
		dataIndex: 'settle_energy_charge',
		scopedSlots: { customRender: 'settle_energy_charge' },
		width: '100px',
		display: true,
	},
	{
		title: '结算时间',
		dataIndex: 'clearing_time',
		scopedSlots: { customRender: 'time' },
		width: '190px',
		display: true,
	},
	{
		title: '结束时间',
		dataIndex: 'finish_time',
		scopedSlots: { customRender: 'time' },
		width: '190px',
		display: true,
	},
];

// 等待用户筛选后再展示列表的类型
const loadingList = [CHARGING_TYPE.ALL, CHARGING_TYPE.ERFUND, CHARGING_TYPE.SUCCESS]

export default {
	name: 'CharingOrderList',
	components: {
        ListLoadingMask: () => import('../../components/common/ListLoadingMask.vue'),
	},
	props: {},
	data() {
		return {
			CHARGING_STATUS,
			userType: Core.Data.getLoginType(),
			LOGIN_TYPE,
			PAY_METHOD,
			CHARGING_TYPE,
			PAY_METHOD_M,
			loading: true,
			init: true, // 是否处于初始化状态
			// 分页
			currPage: 1,
			total: 0,

			type: 0, // 页面类型
			history: false,
			precontract: false,

			// 搜索
			defaultTime: Core.Const.TIME_PICKER_DEFAULT_VALUE.B_TO_B,

			defaultBegin: '',
			defaultEnd: '',

			// 一天的开始时间和结束时间
			startOfDay: '',
			endOfDay: '',

			showDown: false,
			searchForm: {
				type: 0,
				orderSn: '',
				socketUid: '',
				gatewayUid: '',
				outerSn: '',

				nickname: '',
				phone: '',

				order_status: '',
                pursue_order_status: '',
				pay_method: '',
                pay_methods: '',
				settle_status: '',
				refund_status: '',

				finish_code: undefined,
				operator_id: undefined,
				org_id: undefined,
				station_id: undefined,
				device_type: undefined,

				power_mode: undefined,

				alipay_shualan_type: undefined,

				remitTime: {},
				refundTime: {},
				createTime: {
					begin_time: moment().subtract(6, 'd').startOf('D').unix(),
					end_time: moment().endOf('D').unix(),
				},
				finishTime: {},

				flag_booking: undefined, // 充电类型  预约充电 直接充电

				license_plate_number: '',
				vin: '',
			},
			stationList: [],
			orgList: [],
			powerModeList: Object.values(Core.Const.CHARGING.POWER_MODE_MAP),
			flagBookingList: Object.values(Core.Const.ORDER.FLAG_BOOKING_MAP),
			alipayShualanTypeList: Object.values(Core.Const.DEVICE.ALIPAY_SHUALAN_TYPE_MAP).filter(i => i.isSelect),

			// 表格
			tableColumnsTemp: _tableColumns,
			tableData: [],
			selectedRowKeys: [],
            selectedRowItems: [],
			selectOrderList: [], // 选择的订单

			payMethodList: [], // Core.Const.PAY.METHOD_LIST,
			clearingStatusList: Core.Const.CLEARING.STATUS_LIST,
            refundStatusList: Object.values(Core.Const.ORDER.REFUND_STATUS_MAP).filter(i => !i.hidden),
            pursueStatusList: Object.values(Core.Const.CHARGING.PURSUE_ORDER_STATUS_MAP),

			orderExport: {
				disabled: false,
			},

			fieldVisible: false,
			fieldList: [],
			fieldKeys: [],

			SHOW_PARENT,
			value: undefined,

			tipEndTime: moment().subtract(1, 'd').endOf('D').unix(),
		};
	},
	computed: {
		tableColumns() {
			let tableColumns = [];
			tableColumns = this.tableColumnsTemp.filter((item) => item.display);
			console.log("tableColumns  tableColumns:", tableColumns)
			if (this.type === this.CHARGING_TYPE.PRECONTRACT) {
				tableColumns.push({ 
					title: '操作', 
					dataIndex: 'operation', 
					scopedSlots: { customRender: 'operation' },
					display: true,
					width: '100px', 
					fixed: 'right'
				})
			}
            /**
             * 先充后付欠款订单列表 去除“车牌号”列
             * 非先充后付欠款订单列表 去除“欠款状态”列
            */
			if (this.type === CHARGING_TYPE.POSTPAY_FAIL) {
				tableColumns = tableColumns.filter(item => {return item.dataIndex !== 'detail.license_plate_number'})
			} else {
				tableColumns = tableColumns.filter(item => {return item.dataIndex !== 'pursue_order_status'})
            }
			// 除 先充后付、异常、未支付订单列表 外，展示“结算后退款金额”、“结算后退款状态”列
			if ([CHARGING_TYPE.POSTPAY_FAIL, CHARGING_TYPE.ERFUND, CHARGING_TYPE.UNPAY].includes(this.type)) {
				tableColumns = tableColumns.filter(item => {return (item.dataIndex !== 'refund_money' && item.dataIndex !== 'refund_status')})
			}
			console.log('tableColumns:', tableColumns);
			
			return tableColumns;
		},
        statusList() {
            if (this.type === CHARGING_TYPE.POSTPAY_FAIL) {
                return Object.values(Core.Const.CHARGING.STATUS_MAP).filter(i => i.postpay_fail).sort((a, b) => b.order - a.order)
            } else {
                return Object.values(Core.Const.CHARGING.STATUS_MAP).sort((a, b) => b.order - a.order)
            }
        },
		finishCodeNewList() {
			let list =  Object.values(Core.Const.CHARGING.FINISH_CODE_NEW_MAP)
            list = list.filter(i => this.$auth(i.auth) || !i.auth)
			if (this.precontract) {
				// 预约订单列表
				list = list.filter(item => (item.value.indexOf('carac') !== -1 || item.value.indexOf('current') !== -1))
			}
			return list
		},
		rowSelection() {
            const { selectedRowKeys } = this;
            return {
                selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => { // 表格 选择 改变
                    console.log("onSelectChange selectedRowKeys", selectedRowKeys)
                    this.selectedRowKeys = selectedRowKeys;
                    this.selectedRowItems = selectedRows;

					this.selectOrderList=this.selectOrderList.concat(selectedRows);
                    this.selectOrderList=this.selectOrderList.filter(item=>this.selectedRowKeys.indexOf(item.id)!=-1)
					//数组对象去重
					let map = new Map();
					for (let item of this.selectOrderList) {
						if (!map.has(item.id)) {
							map.set(item.id, item);
						};
					};
					this.selectOrderList = [...map.values()];
					console.log(' this.selectOrderList ', this.selectOrderList )
                },
				getCheckboxProps: record => ({
                    props: {
                        // 不可结算：先充后付免费订单、先充后付已结算成功订单
                        disabled: (record.pay_method === PAY_METHOD.CHARGE_FIRST && record.clearing_status === Core.Const.CLEARING.STATUS.SUCCESS) || record.pay_method === PAY_METHOD.CHARGE_FIRST_FREE
                    },
                }),
            };
        },
        deviceTypeList() {
            let list = Object.values(Core.Const.DEVICE.TYPE_MAP).filter(i => (this.$auth(i.auth) || !i.auth) && i.is_device_type)
            return list
        },
	},
	filters: {
		moneyConsumedFilter(detail) {
			let price = '';
			if (detail.price >= detail.money_consumed) {
				price = detail.money_consumed;
			} else {
				price = detail.price;
			}
			if (price > detail.charge) {
				price = detail.charge;
			}
			return Core.Util.countFilter(price);
		},
	},
	mounted() {
		this.type = this.$route.meta.type;
		this.searchForm.type = this.$route.meta.type;
		if (this.type === CHARGING_TYPE.TODAY) {
			this.searchForm.createTime = {
				begin_time: this.startOfDay.unix(),
				end_time: this.endOfDay.unix(),
			};
		} else if (this.type === CHARGING_TYPE.ALL) {
			this.searchForm.createTime = {
				begin_time: moment().subtract(7, 'd').startOf('D').unix(),
				end_time: moment().subtract(1, 'd').endOf('D').unix(),
			};
		} else if (this.type === CHARGING_TYPE.POSTPAY_FAIL) {
            this.searchForm.createTime = {}
		}

		if (!this.$auth('ADMIN')) {
			this.searchForm.operator_id = Core.Data.getUser().id;
		}

		const fieldKeys = Core.Data.getOrderField() || [];
		if (fieldKeys.length) {
			this.tableColumnsTemp.forEach((item) => {
				if (fieldKeys.includes(item.dataIndex)) {
					item.display = true;
				} else {
					item.display = false;
				}
			});
		}

		// this.handleHintShow();

		this.getCharingPayMethodList();
	},
	watch: {
		'searchForm.operator_id': function (newVal) {
			if (newVal) {
				this.getOrgList(newVal);
				this.getStationList(newVal);
			} else {
				this.orgList = [];
				this.stationList = [];
			}
			this.searchForm.org_id = undefined;
			this.searchForm.station_id = undefined;
			// this.handleSearch()
		},
		'searchForm.org_id': function (newVal) {
			if (newVal) {
				this.getStationListByOrg(newVal);
			} else if (this.searchForm.operator_id) {
				this.getStationList(this.searchForm.operator_id);
			} else {
				this.stationList = [];
			}
			this.searchForm.station_id = undefined;
			// this.handleSearch()
		},
		$route: {
			deep: true,
			immediate: true,
			handler(newRoute) {
				console.log('newRoute.meta.type watch:', newRoute.meta.type);
                this.tableColumnsTemp = Core.Util.deepCopy(_tableColumns)
				this.type = newRoute.meta.type;
				this.searchForm.type = newRoute.meta.type;
				this.history = Number(newRoute.meta.history) ? true : false;
				this.precontract = Number(newRoute.meta.precontract) ? true : false;
				// 更新时间
				this.startOfDay = moment().hour(0).minute(0).seconds(0);
				console.log("handler  this.startOfDay:", this.startOfDay)
				this.endOfDay = moment().hour(23).minute(59).seconds(59);
				console.log("handler  this.endOfDay:", this.endOfDay)

				this.handleSearchReset();
				if (!loadingList.includes(this.type)) {
					this.init = false
				} else {
					this.init = true
					this.total = 0;
					this.tableData = [];
					this.loading = false
				}
			},
		},
	},
	methods: {
		handleHintShow() {
			if (this.type === 0 && !this.history) {
				let flag = JSON.stringify(Core.Data.getOrderListHint());
				if (flag === 'null') {
					const key = `open${Date.now()}`;
					this.$notification.info({
						key,
						message: '提示',
						description: '默认展示近七天内的订单，更多历史记录，请通过时间筛选查看或在“历史订单”中查看',
						duration: 0,
						btn: (h) => {
							return [
								h(
									'a-button',
									{
										on: {
											click: () => {
												Core.Data.setOrderListHint('close');
												this.$notification.close(key);
											},
										},
									},
									'不再提示'
								),
								h(
									'a-button',
									{
										props: { type: 'primary' },
										on: {
											click: () => this.$notification.close(key),
										},
									},
									'知道了'
								),
							];
						},
						onClose: () => {
							console.log('onClose');
						},
					});
				}
			}
		},
		pageChange(page) {
			this.currPage = page;
			this.getTableData();
		},
		routerChange(index, item) {
			switch (index) {
				case 1: {
					let routeUrl = this.$router.resolve({
						path: '/charing-order/order-detail',
						query: {
							id: item.id,
						},
					});
					window.open(routeUrl.href, '_blank');
				}
			}
		},
		handleFilterChange(key, value) {
			this.searchForm[key] = value;
			this.handleSearch();
		},
		handleSearch() {
			// if (loadingList.includes(this.type)) {
			// 	const result = this.handleCheckObjEmpty()
			// 	if (!result) return
			// }
			this.init = false
			// 搜索
			this.pageChange(1);
		},
		handleSearchReset() {
			// 重置搜索
			Object.assign(this.$data.searchForm, this.$options.data().searchForm);
			if (this.$auth('OPERATOR')) {
				this.searchForm.operator_id = Core.Data.getUser().id;
			}
			if (this.type === CHARGING_TYPE.TODAY) {
				this.searchForm.createTime = {
					begin_time: this.startOfDay.unix(),
					end_time: this.endOfDay.unix(),
				};
				console.log("handleSearchReset  this.searchForm.createTime:", this.searchForm.createTime)
				this.defaultBegin = this.startOfDay;
				console.log("handleSearchReset  this.defaultBegin:", this.defaultBegin)
				this.defaultEnd = this.endOfDay;
			} else if (this.type === CHARGING_TYPE.ALL) {
				this.searchForm.createTime = {
					begin_time: moment().subtract(7, 'd').startOf('D').unix(),
					end_time: moment().subtract(1, 'd').endOf('D').unix(),
				};
				console.log("handleSearchReset  this.defaultEnd:", this.defaultEnd)
			} 
			if (this.type === CHARGING_TYPE.POSTPAY_FAIL) {
				console.log('POSTPAY_FAIL');
                this.searchForm.createTime = {}
			} else {
				this.searchForm.type = this.$route.meta.type
			}

			// 重置搜索条件后查询
			if (loadingList.includes(this.type)) {
				this.init = true
				this.total = 0;
				this.tableData = [];
			} else {
				this.selectOrderList = [];
				this.selectedRowKeys = [];
				this.selectedRowItems = [];
				this.pageChange(1);
			}
		},
		handleBeginTimeChange(val) {
			this.searchForm.createTime.begin_time = val;
			this.defaultBegin = moment.unix(val);
			// this.handleSearch()
		},
		handleEndTimeChange(val) {
			if (val && this.searchForm.createTime.begin_time == val) {
				val = parseInt(val) + 1 + '';
			}
			this.searchForm.createTime.end_time = val;
			this.defaultEnd = moment.unix(val);
			// this.handleSearch()
		},
		// 计算时间跨度是否大于31天
		handleTimeChange(key) {
			let { begin_time, end_time } = this.searchForm[key];
			let diff = Core.Util.diffOfTime(begin_time, end_time) + 1;
			if (diff > 31) {
				this.$message.warning('请将日期查询范围控制在31天内');
				return true;
			}
			return false;
		},

		getTableData() {
			// 获取表格数据
			if (this.handleTimeChange('createTime') || this.handleTimeChange('finishTime') || this.handleTimeChange('remitTime') || this.handleTimeChange('refundTime')) {
				return;
			}
			console.log('finish_code:', this.searchForm.finish_code);

			this.loading = true;
			let form = Core.Util.deepCopy(this.searchForm);
			console.log("getTableData  form:", form)

			if (this.type !== CHARGING_TYPE.POSTPAY_FAIL) {
				form.type = this.$route.meta.type
			}

            // 运营商端因只展示一个先充后付筛选方式，查询时传pay_methods: 17，18
            if (this.$auth('OPERATOR') && form.pay_method === PAY_METHOD.CHARGE_FIRST) {
                form.pay_method = ''
                form.pay_methods = '17,18'
            }

			let { begin_time = '', end_time = '' } = form.createTime;
			let { begin_time: finish_begin_time = '', end_time: finish_end_time = '' } = form.finishTime;
			let { begin_time: clearing_begin_time = '', end_time: clearing_end_time = '' } = form.remitTime;
			let { begin_time: refund_begin_time = '', end_time: refund_end_time = '' } = form.refundTime;

			if (end_time === begin_time && end_time) {
				end_time++;
			}
			if (finish_end_time === finish_begin_time && finish_end_time) {
				finish_end_time++;
			}
			if (clearing_end_time === clearing_begin_time && clearing_end_time) {
				clearing_end_time++;
			}
			if (refund_end_time === refund_begin_time && refund_end_time) {
				refund_end_time++;
			}

			let apiName = 'list';
			/**
			 * this.type,
				this.currPage,
				form.orderSn,
				form.outerSn,
				form.socketUid,
				form.gatewayUid,
				form.nickname,
				form.phone,
				form.operator_id,
				form.org_id,
				form.station_id,
				form.station_type,
				form.order_status,
				form.pay_method,
				form.settle_status,
				form.finish_code,
				form.power_mode,
				begin_time,
				end_time,
				clearing_begin_time,
				clearing_end_time,
				finish_begin_time,
				finish_end_time,
				form.license_plate_number,
				this.precontract ? FLAG_BOOKING.PRECONTRACT : form.flag_booking,
				form.vin,
			 */
			let params = this.type !== CHARGING_TYPE.POSTPAY_FAIL ? {
				type: form.type,
				page: this.currPage,
				sn: form.orderSn,
				outer_sn: form.outerSn,
				socket_uid: form.socketUid,
				gateway_uid: form.gatewayUid,
				nickname: form.nickname,
				user_phone: form.phone,
				operator_id: form.operator_id,
				org_id: form.org_id,
				station_id: form.station_id,
				device_type: form.device_type,
				status: form.order_status,
				pay_method: form.pay_method,
                pay_methods: form.pay_methods,
				clearing_status: form.settle_status,
				refund_status: form.refund_status,
				finish_code: form.finish_code,
				power_mode: form.power_mode,
				vin: form.vin,
				begin_time,
				end_time,
				clearing_begin_time,
				clearing_end_time,
				finish_begin_time,
				finish_end_time,
				refund_begin_time,
				refund_end_time,
				license_plate_number: form.license_plate_number.toLocaleUpperCase(),
				flag_booking: form.flag_booking,
				alipay_shualan_type: form.alipay_shualan_type,
			} : {
                page: this.currPage,
                power_order_sn: form.orderSn,
                power_outer_sn: form.outerSn,
                socket_uid: form.socketUid,
				gateway_uid: form.gatewayUid,
				nickname: form.nickname,
                user_phone: form.phone,
				operator_id: form.operator_id,
				org_id: form.org_id,
                station_id: form.station_id,
				device_type: form.device_type,
                begin_time: finish_begin_time,
				end_time: finish_end_time,
				status: form.pursue_order_status,
            }
			if (this.precontract) {
				params.flag_booking = FLAG_BOOKING.PRECONTRACT
				apiName = 'precontractList'
			}
			if (this.history) {
				apiName = 'historyList'
			}
            if (this.type === CHARGING_TYPE.POSTPAY_FAIL) {
                apiName = 'pursueList'
            }
			Core.Api.Order[apiName](params)
				.then(async (res) => {
					console.log('getTableData res', res);
					this.total = res.count;

					let list = this.type !== CHARGING_TYPE.POSTPAY_FAIL ? res.order_list : Core.Util.deepCopy(res.list).map(i => ({...i.order, pursue_order_status: i.status}));
					// 计算实际收费
					for (let i = 0; i < list.length; i++) {
						const item = list[i];
						let charge = await this.handleCharge(item);
						item.sum_price_info = {charge};
					}
					console.log('getTableData list', list);
					this.tableData = list;

					this.loading = false;
				})
				.catch((err) => {
					this.loading = false;
					console.log('getTableData err', err);
				});
		},
		// 计算charge
		handleCharge(order) {
			const M = Core.Const.INSURANCE.STATUS_MARK;
    		const REFUND_M = Core.Const.INSURANCE.REFUND_STATUS_MARK;
			const REFUND_STATUS = Core.Const.ORDER.REFUND_STATUS;
			const CHARGE_MODE_MARK = Core.Const.CHARGE.CHARGE_MODE_MARK;
			const FLAG_BOOKING = Core.Const.ORDER.FLAG_BOOKING;

			let charge = order.charge;
			const insurance = order.insurance || {};
			const flag_charge_first = PAY_METHOD_M.CHARGE_FIRST.includes(order.pay_method); // 是否为先充后付订单
			const flag_pre_car = CHARGE_MODE_MARK.CAR.includes(order.charge_mode) && order?.detail?.flag_booking === FLAG_BOOKING.PRECONTRACT // 是否为汽车充预约充电订单
			const booking_order = order.booking_order || {}
			const flag_time_card = PAY_METHOD_M.TIME_CARD.includes(order.pay_method) // 是否为包月卡
			
			// 是否有充电费退款
			if (order.refund_status) {
				charge = charge - order.refund_money;
			}
			// 占位费
			if (flag_pre_car && !Core.Util.isEmptyObj(booking_order)) {
				// 是否有占位费退款
				if (booking_order.occupy_refund_status && booking_order.occupy_refund_status === REFUND_STATUS.ALL_SUCCESS) {
					charge = charge - booking_order.occupy_refund_money;
				}
			}
			// 安心充
			if (!Core.Util.isEmptyObj(insurance)) {
				// 安心充是否出单成功
				if ((!flag_charge_first && M.SUCCESS.includes(insurance.status)) || (flag_charge_first && [...M.CHARGE_FIRST_SUCCESS, -420].includes(insurance.status))) {
					charge = charge + insurance.money;
					// 是否有安心充退款
					if ((insurance.refund_status && REFUND_M.REFUND_SUCCESS.includes(insurance.refund_status)) || M.FAIL.includes(insurance.status)) {
						charge = charge - insurance.refund_money;
					}
				}
			}
			return charge;
		},
		async getCharingPayMethodList() {
			this.payMethodList = await Core.Util.getCharingPayMethodList()
		},
		getOrgList(operatorId) {
			// 获取选择用 片区 列表
			Core.Api.Org.listName(operatorId).then((res) => {
				console.log('getOrgList res', res);
				this.orgList = res.org_list;
			});
		},
		getStationList(operatorId) {
			// 获取选择用 充电站 列表
			Core.Api.Station.listAll(operatorId).then((res) => {
				console.log('getStationList res', res);
				this.stationList = res.station_list;
			});
		},
		async getStationListByOrg(org_id) {
			// 获取选择用 充电站 列表
			if (!org_id) {
				this.stationList = [];
				return;
			}
			let page = 1;
			let total = 0;
			this.stationList = [];

			await Core.Api.Station.listByOrgId(page, org_id).then((res) => {
				this.stationList = res.station_list;
				total = res.count;
			});
			for (let i = 20; i < total; i = i + 20) {
				page++;
				await Core.Api.Station.listByOrgId(page, org_id).then((res) => {
					this.stationList = [...this.stationList, ...res.station_list];
				});
			}
			console.log('getStationList res', this.stationList);
		},
		async handleExportConfirm(flag_vip) {
			// 确认订单是否导出
			// 检查是否有到导出中的任务
			if (this.$auth('OPERATOR')) {
				try {
					let { list } = await Core.Api.Order.exportList(1, 1);
					console.log('getExportList list:', list);
					if (list.some((item) => item.status === Core.Const.EXPORT.STATUS.DOING)) {
						return this.$message.warning('您有一份正在进行中的导出任务，请等待该任务结束后再进行导出。');
					}
				} catch (err) {
					console.log('getExportList err:', err);
				}
			}

			let form = Core.Util.deepCopy(this.searchForm);

			// 检查时间跨度
			if (this.handleTimeChange('createTime') || this.handleTimeChange('finishTime') || this.handleTimeChange('remitTime')) {
				return;
			}

			let { begin_time = '', end_time = '' } = form.createTime;
			let { begin_time: finish_begin_time = '', end_time: finish_end_time = '' } = form.finishTime;
			let { begin_time: clearing_begin_time = '', end_time: clearing_end_time = '' } = form.remitTime;
			let { begin_time: refund_begin_time = '', end_time: refund_end_time = '' } = form.refundTime;

			// 要求 选择时间范围
			let list = [begin_time, end_time, finish_begin_time, finish_end_time, clearing_begin_time, clearing_end_time, refund_begin_time, refund_end_time];
			if (list.every((i) => !i)) {
				return this.$message.warning('请选择导出订单的时间范围');
			}

			// 时间范围不重合
			if (end_time === begin_time && end_time) {
				end_time++;
			}
			if (finish_end_time === finish_begin_time && finish_end_time) {
				finish_end_time++;
			}
			if (clearing_end_time === clearing_begin_time && clearing_end_time) {
				clearing_end_time++;
			}
			if (refund_end_time === refund_begin_time && refund_end_time) {
				refund_end_time++;
			}

			let params = {
				begin_time,
				end_time,
				operator_id: form.operator_id ? form.operator_id : '',
				org_id: form.org_id ? form.org_id : '',
				station_id: form.station_id ? form.station_id : '',
				status: form.order_status,
				pay_method: form.pay_method,
				gateway_uid: form.gatewayUid,
				user_name: form.nickname,
				user_phone: form.phone,
				clearing_status: form.settle_status,
				clearing_begin_time,
				clearing_end_time,
				finish_begin_time,
				finish_end_time,
				refund_begin_time,
				refund_end_time,
				flag_vip: flag_vip ? 1 : 0,
				type: this.type
			}

			if (this.precontract) {
				params.flag_booking = FLAG_BOOKING.PRECONTRACT
			}

			// 生成任务接口连接
			let exportUrl = Core.Util.getExportUrl('export-task/create-order-export', params);
			console.log('handleOrderExport exportUrl:', exportUrl);

			this.$confirm({
				title: `确认要生成${flag_vip ? "VIP" : ""}导出任务吗？`,
				okText: '确定',
				cancelText: '取消',
				onOk: () => {
					this.handleOrderExport(exportUrl);
				},
			});
		},
		handleOrderExport(exportUrl) {
			// 订单导出
			if (this.orderExport.disabled) {
				return;
			}
			this.orderExport.disabled = true;

			axios
				.post(exportUrl)
				.then((res) => {
					console.log('handleOrderExport res', res);
					this.orderExport.disabled = false;
					if (res.data.code === 0) {
						this.$message.success('导出任务已生成，请前往导出列表查看');
					} else {
						this.$message.error('导出任务失败:' + res.data.message);
					}
				})
				.catch((err) => {
					console.log('handleOrderExport err', err);
					this.$message.error('导出任务失败');
					this.orderExport.disabled = false;
				});
		},

		// 选择展示字段
		handleFieldSelectShow() {
			this.fieldVisible = true;
			const disabled_key = ['sn'];
			this.fieldList = [];
			this.fieldKeys = [];
            /**
             * 先充后付欠款订单列表 去除“车牌号”列
             * 非先充后付欠款订单列表 去除“欠款订单”列
            */
			if (this.type === CHARGING_TYPE.POSTPAY_FAIL) {
				this.tableColumnsTemp = this.tableColumnsTemp.filter(item => {return item.dataIndex !== 'detail.license_plate_number'})
			} else {
				this.tableColumnsTemp = this.tableColumnsTemp.filter(item => {return item.dataIndex !== 'pursue_order_status'})
            }
			// 除 先充后付、异常、未支付订单列表 外，展示“结算后退款金额”、“结算后退款状态”列
			if ([CHARGING_TYPE.POSTPAY_FAIL, CHARGING_TYPE.ERFUND, CHARGING_TYPE.UNPAY].includes(this.type)) {
				this.tableColumnsTemp = this.tableColumnsTemp.filter(item => {return (item.dataIndex !== 'refund_money' && item.dataIndex !== 'refund_status')})
			}
			console.log('tableColumnsTemp:', this.tableColumnsTemp);
			
			this.tableColumnsTemp.forEach((item) => {
				this.fieldList.push({
					label: item.title,
					value: item.dataIndex,
					display: item.display,
					disabled: disabled_key.includes(item.dataIndex),
				});
				if (item.display) {
					this.fieldKeys.push(item.dataIndex);
				}
			});
			console.log('this.fieldList:', this.fieldList);
		},
		handleFieldSelectClose() {
			this.fieldVisible = false;
			Core.Data.setOrderField(this.fieldKeys);
		},
		handleFieldSelectConfirm() {
			this.tableColumnsTemp.forEach((item) => {
				if (this.fieldKeys.includes(item.dataIndex)) {
					item.display = true;
				} else {
					item.display = false;
				}
			});
			this.handleFieldSelectClose();
		},
		// 取消预约
		handleCancelPrecontract(record) {
			console.log("handleCancelPrecontract  record:", record)
			if (this.loading) return 
			if (!record.sn) return this.$message.error("订单sn有误")
			this.$confirm({
				title: `确定取消预约？`,
				okText: '确定',
				cancelText: '取消',
				onOk:() => {
					this.loading = true;
					Core.Api.Order.closePreOrder(record.sn).then(res => {
						console.log("handlePreOrderCancel res:", res)
						this.$message.success('取消预约成功')
					}).catch(err => {
						console.log("handlePreOrderCancel err:", err)
						this.$message.error('取消预约失败')
					}).finally(() => {
						this.loading = false;
						this.getTableData()
					})
				}
			})
		},

		// 批量结算订单
		handleBatchClearingOrder() {
			const order_ids = this.selectOrderList.map(i => i.id).join(',')
			this.$confirm({
				title: `确定要立即结算${this.selectedRowKeys.length}笔订单吗？`,
				okText: '确定',
				cancelText: '取消',
				onOk: () => {
					this.loading = true;
					Core.Api.Order.batchManualClearing(order_ids, Core.Const.ORDER.TYPE.CHARING)
						.then(() => {
							this.$message.success('操作成功');
						})
						.catch((err) => {
							console.log('hanldeManualClearing err:', err);
							this.$message.success('操作失败');
						})
						.finally(() => {
							this.loading = false;
							this.selectOrderList = [];
							this.selectedRowKeys = [];
            				this.selectedRowItems = [];
							this.getTableData()
						})
				},
			});
		},

		// 不可选择日期
        disabledDate(current) {
            return this.type === CHARGING_TYPE.ALL && !history ? current && current > moment().subtract(1, 'd').endOf('d') : false;
        },

		// 判断搜索条件是否更改
        handleCheckObjEmpty() {
            let form = Core.Util.deepCopy(this.searchForm);
            let resultList = []
            for (const key in form) {
                switch (key) {
                    case 'operator_id':
                        if (this.$auth('ADMIN')) {
                            resultList.push(form[key] ? true : false)
                        }
                        break;
					// 设备类型 为0
					case 'device_type':
						if (form[key] !== undefined) {
							resultList.push(true)
                        } else {
							resultList.push(false)
                        }
                        break;
					// TODO 结束原因 两轮-正常停止 为0
                    case 'createTime':
						const create_time = {
							begin_time: moment().subtract(7, 'd').startOf('D').unix(),
							end_time: moment().subtract(1, 'd').endOf('D').unix(),
						}
						const same = Core.Util.isSameObjs(form[key], create_time)
						resultList.push(!same)
                        break;
                    case 'finishTime':
                    case 'refundTime':
                    case 'remitTime':
                        resultList.push(!Core.Util.isEmptyObj(form[key]))
                        break;
                
                    default:
                        resultList.push(form[key] ? true : false)
                        break;
                }
            }
            console.log('resultList:', resultList);
            return resultList.some(i => i)
        },
	},
};
</script>

<style lang="scss" scoped>
#CharingOrderList {
	position: relative;
	.operate-container {
		.btn-area {
			width: 164px;
			.operate-icon {
				transition: all 0.3s linear;
				&.up {
					transform: rotate(180deg);
				}
			}
		}
		.search-area {
			width: calc(100% - 165px);
			min-width: 300px;
			overflow: hidden;
			transition: height 0.3s ease;
			padding-top: 2px;
			.search-item {
				.value {
					min-width: 180px;
				}
			}
			&.one-line {
				height: 38px;
			}

			@media (max-width: 992px) {
				// lg以下 一行一个
				&.multi-line.admin {
					height: calc(38px * 16);
					&.today { height: calc(38px * 14);}
					&.history { height: calc(38px * 12); }
					&.precontract { height: calc(38px * 13); }
					&.refund { height: calc(38px * 17); }
                    &.postpay-fail { height: calc(38px * 10); }
				}
				&.multi-line.sp {
					height: calc(38px * 15);
					&.today { height: calc(38px * 13); }
					&.history { height: calc(38px * 11); }
					&.precontract { height: calc(38px * 12); }
					&.refund { height: calc(38px * 16); }
				}
			}
			@media (min-width: 992px) {
				// lg 一行两个
				&.multi-line.admin {
					height: calc(38px * 10);
					&.today { height: calc(38px * 7); }
					&.history { height: calc(38px * 8); }
					&.precontract { height: calc(38px * 8); }
					&.refund { height: calc(38px * 11); }
                    &.postpay-fail { height: calc(38px * 6); }
				}
				&.multi-line.sp {
					height: calc(38px * 9);
					&.today { height: calc(38px * 7); }
					&.history { height: calc(38px * 7); }
					&.precontract { height: calc(38px * 8); }
					&.refund { height: calc(38px * 10); }
				}
			}
			@media (min-width: 1200px) {
				// xl 一行三个
				&.multi-line.admin {
					height: calc(38px * 7);
					&.today { height: calc(38px * 5);}
					&.history { height: calc(38px * 6); }
					&.precontract { height: calc(38px * 6); }
					&.refund { height: calc(38px * 8); }
                    &.postpay-fail { height: calc(38px * 4); }
				}
				&.multi-line.sp {
					height: calc(38px * 7);
					&.today { height: calc(38px * 5);}
					&.history { height: calc(38px * 5); }
					&.precontract { height: calc(38px * 6); }
					&.refund { height: calc(38px * 8); }
				}
			}
			@media (min-width: 1600px) {
				// xxl 一行四个
				&.multi-line.admin {
					height: calc(38px * 5);
					&.today { height: calc(38px * 4);}
					&.history { height: calc(38px * 4); }
					&.precontract { height: calc(38px * 4); }
					&.refund { height: calc(38px * 6); }
                    &.postpay-fail { height: calc(38px * 3); }
				}
				&.multi-line.sp {
					height: calc(38px * 5);
					&.today { height: calc(38px * 4);}
					&.history { height: calc(38px * 4); }
					&.precontract { height: calc(38px * 4); }
					&.refund { height: calc(38px * 5); }
				}
			}
		}
	}
	.table-container {
		table span {
			display: inline-block;
		}
	}
}
</style>
<style lang="scss">
.select-tip {
	&.ant-tooltip-placement-left {
		padding-right: 56px;
		.ant-tooltip-arrow {
			right: 43px;
		}
	}
}
</style>
